import React from "react";
import { motion } from "framer-motion";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.4 } },
};

const HowToGetStarted = () => {
    const steps = [
        {
            title: "Connect With Us",
            description: "Submit a simple online inquiry through our website or visit our conveniently located MMR office for a personal consultation."
        },
        {
            title: "Free Assessment",
            description: "Receive a complimentary eligibility assessment and comprehensive loan comparison across multiple lenders with no obligations."
        },
        {
            title: "Dedicated Guidance",
            description: "A personal loan advisor is assigned to your case, providing expert guidance and answering all your questions."
        },
        {
            title: "Fast-Track Approval",
            description: "Benefit from our streamlined application process and accelerated approval timelines, getting you funded quickly and efficiently."
        }
    ];

    return (
        <motion.div
            className="how-to-get-started-section"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >
            <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                <span className="horizontal-line"></span>How to Get Started
            </motion.h2>
            <motion.p className="sections-description-smco" variants={scrollReveal}>
                Follow these simple steps to secure your loan with Magnify Advaisory.
            </motion.p>

            <motion.div className="how-to-steps-container" variants={staggerContainer}>
                {steps.map((step, index) => (
                    <motion.div
                        key={index}
                        className="how-to-step"
                        variants={scrollReveal}
                    >
                        <motion.div className="step-number" variants={scrollReveal}>
                            {index + 1}
                        </motion.div>
                        <motion.h3 className="step-title" variants={scrollReveal}>
                            {step.title}
                        </motion.h3>
                        <motion.p className="step-description" variants={scrollReveal}>
                            {step.description}
                        </motion.p>
                    </motion.div>
                ))}
            </motion.div>
        </motion.div>
    );
};

export default HowToGetStarted;
